import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import BoxEditor from "./BoxEditor";
import PaymentList from "./lists/paymentList";
import PaymentForm from "./forms/paymentForm";
import isEqual from 'lodash-es/isEqual';
import Button from "../form/Button";
import {postData} from "../../utils/request";
import PurchaseList from "./lists/purchaseList";
import {set} from "../../utils/dotutils";
import ModalEditor from "./ModalEditor";
import ComponentConfig from "../form/ComponentConfig";
import ComponentLoader from "../form/ComponentLoader";
import {list} from "../../utils/array";
import Confirm from "../form/Confirm";
import {CurrencyFormatter} from "../../utils/formatters";
import {connect} from "src/store";
import {operation} from "../../utils/other";

const stateConst = {
    initiated: 0,
    pending: 50,
    completed: 100,
    failed: 600,
    deleted: 900
};

const stateType = {};
Object.keys(stateConst).forEach((key) => {
    stateType[key] = (state, operator) => operation(state, stateConst[key], operator)
});

class paymentEditor extends React.Component {

    state = {
        reverseAccept: {}
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.values[prevProps.componentConfig.idfield] + "" !== "" + this.props.values[this.props.componentConfig.idfield]) {
            this.setState({reverseAccept: {}});
        }
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    deleteForm = async (event) => {
        await this.props.deleteForm(event);
        this.list && this.list.refresh();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    checkPaymentStatus = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.values.serviceprovider_type + '.checkPaymentStatus',
                id: this.props.values.serviceprovider_id
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    sendNotificationEmail = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.sendNotificationEmail',
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                usercall: true
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    reverseAccept = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.reverseAccept',
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                params: this.state.reverseAccept
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    render() {

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const props = {...this.props};

        const state = this.props.values.state || "0";

        const editorButtons = [];
        if (
            ["Kh","SimplePay","SimplePayAdvanceTransfer","DelayedPayment"].indexOf(this.props.values.serviceprovider_type) !== -1
            && stateType.pending(state, "<=")
            && this.props.values[this.props.componentConfig.idfield]
        ) {
            if (stateType.pending(state)) {
                editorButtons.push(
                    <Button
                        disabled={this.props.isLoading}
                        color="default"
                        className="pull-right"
                        onClick={this.checkPaymentStatus}
                    >
                        Állapot lekérdezés
                    </Button>
                );
            }
            if ((this.props.values.reversal || "1") === "1") {
                editorButtons.push(
                    <Button
                        disabled={this.props.isLoading}
                        color="default"
                        className="pull-right"
                        onClick={this.sendNotificationEmail}
                    >
                        Email küldése
                    </Button>
                );
            }
        }
        if ((this.props.values.reversal || "1") !== "1" && stateType.pending(state, "<=")) {
            editorButtons.push(
                <Button
                    disabled={this.props.isLoading || props.dirty}
                    color="warning"
                    className="pull-right"
                    onClick={this.reverseAccept}
                >
                    Visszatérítés
                </Button>
            );
        }
        if (["Cash","Bankcard"].indexOf(this.props.values.serviceprovider_type) !== -1 && parseInt(state) <= stateConst.pending) {
            editorButtons.push(
                <Confirm
                    disabled={this.props.isLoading || props.dirty || !this.props.context.till}
                    tooltip={!this.props.context.till ? "Kérlek jelentkezz be egy pénztárba!" : null}
                    color={this.props.values.direction + "" === "1" ? "success" : "danger"}
                    className="pull-right"
                    header="Biztos?"
                    body={this.props.values.direction + "" === "1" ? <Fragment>
                        Biztos beteszel <b className="inline">{CurrencyFormatter(this.props.values.amount)}</b>-ot?
                    </Fragment> : <Fragment>
                        Biztos kiveszel <b className="inline">{CurrencyFormatter(this.props.values.amount)}</b>-ot?
                    </Fragment>}
                    acceptButton={this.props.values.direction + "" === "1" ? "Betét" : "Kivét"}
                    onAccept={async () => await this.props.processAction(async ({componentAction}) => await componentAction("executePayment"))}
                >
                    {this.props.values.direction + "" === "1" ? "Betét" : "Kivét"}
                </Confirm>
            );
        }

        const actionButtons = [];

        if (props.businessComponent) {
            let {listFilter} = props;
            if (!listFilter) {
                listFilter = [];
            } else {
                if (Array.isArray(listFilter)) {
                    listFilter = [...listFilter];
                } else if (!listFilter) {
                    listFilter = [listFilter];
                }
            }
            props.listFilter = [
                {
                    field: "component_type",
                    value: props.businessComponent.componentConfig.componentname
                },{
                    field: "component_id",
                    value: props.businessComponent.values[props.businessComponent.componentConfig.idfield]
                },
                ...listFilter
            ];
            if (!this.props.disable) {
                actionButtons.push(
                    <Button
                        key="0"
                        disabled={props.isLoading}
                        color="default"
                        onClick={this.pristineForm}
                    >
                        Új
                    </Button>
                );
                editorButtons.push(
                    <Button
                        key="1"
                        disabled={!this.props.values[this.props.componentConfig.idfield] || props.isLoading}
                        color="danger"
                        className="pull-left"
                        onClick={this.deleteForm}
                    >
                        Törlés
                    </Button>
                );
            }
        }
        if (stateType.initiated(state)) {
            editorButtons.push(
                <Button
                    disabled={(this.props.values[this.props.componentConfig.idfield] && !stateType.initiated(state)) || !props.dirty || props.isLoading}
                    color="primary"
                    className="pull-right"
                    onClick={this.saveForm}
                >
                    Mentés
                </Button>
            );
        }

        const disabled = this.props.isLoading || this.props.disable || stateType.initiated(state, ">");

        const initialReverseAccept = {
            amount: this.props.values.amount,
            reversal: -1
        }

        let reverseAccept = this.state.reverseAccept || initialReverseAccept;
        reverseAccept.amount = this.props.values.amount;
        reverseAccept.reversal = -1;

        return (
            <Fragment>
                <List
                    {...props}
                    collapsed={props.collapsed || false}
                    theme="default"
                    header={"Fizetések"}
                    footer={actionButtons}
                >
                    <PaymentList
                        ref={(el) => this.list = el}
                        {...props}
                        stateConst={stateConst}
                        stateType={stateType}
                        filter={props.listFilter}
                        loadForm={this.loadForm}
                    />
                </List>
                <Editor
                    {...props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={((props.values.prefix || "") + (props.values.billnum || "")) + " Fizetés"}
                    footer={editorButtons}
                >
                    <PaymentForm
                        {...props}
                        disabled={disabled}
                        stateConst={stateConst}
                        stateType={stateType}
                        reverseAccept={reverseAccept}
                        setReverseValue={(field, value) => {
                            if (!field) {
                                if (!value) {
                                    value = {...initialReverseAccept};
                                }
                                this.setState({reverseAccept: value});
                            } else {
                                let reverseAccept = JSON.parse(JSON.stringify(this.state.reverseAccept))
                                set(reverseAccept, field, value);
                                this.setState({reverseAccept});
                            }
                        }}
                    />
                </Editor>
            </Fragment>
        );
    }
}

const PaymentEditor = connect((state) => {
    return {
        context: state.app.context,
    }
}, {})(createEditor({
    componentName: "payment",
    WrappedComponent: paymentEditor,
    props: {
        view: "admin"
    }
}));

export default PaymentEditor;

export const ReversePaymentsEditor = (props) => {
    return <PaymentEditor editorContext="ReversePayments" {...props} listFilter={list(props.listFilter, {field: "reversal", value: -1})} />;
}


const PaymentComponent = (props) => {
    return <PaymentEditor
        disable={props.disable}
        editorContext="purchasePaymentEditor"
        pageSize={0}
        presets={{
            component_type: props.componentConfig.componentname,
            component_id: props.values[props.componentConfig.idfield],
            client_component: props.client.componentConfig.componentname,
            client_component_id: props.client.values[props.componentConfig.idfield],
        }}
        businessComponent={props}
        editor={ModalEditor}
        selection={null}
        onProcessAction={() => {
            if (!props.isLoading) {
                props.reloadForm && props.reloadForm();
            }
        }}
    />;
}

export const Payments = (props) => {
    return <ComponentConfig componentName="businesstransaction" componentConfigAs="client.componentConfig">
        <ComponentLoader componentName="businesstransaction" componentAs="client.values" filter={[
            {
                field: "client_component",
                value: props.componentConfig.componentname
            },
            {
                field: "client_component_id",
                value: props.values[props.componentConfig.idfield]
            }
        ]}>
            <PaymentComponent {...props} />
        </ComponentLoader>
    </ComponentConfig>
}

